import React from "react";
import Translator from "Languages/Utility/Translator";
import * as Icons from 'react-bootstrap-icons';

export default function TypePayFormatter(cell) {
  return (
    <div className={`satp_num${cell}`}>
      {
       {
         1: <Icons.Wallet2 size={15}/>,
         2: <Icons.Bank size={15}/>,
       }[cell]
      }
      {" "}
      {
        (cell !== 1 && cell !== 2)
          ? <Translator id='undefined' />
          : <Translator id={`satp_num${cell}`} noSpan />
      }
     </div>
  );
}